var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { InMemoryRepo } from "@/background/store/InMemoryDb";
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { LetrRequestType } from "@/share/Letr";
import { LetrLoadStatus } from "@/share/models";
import { TagRequestType } from "@/share/Tag";
import { DEFAULT_TAGS } from "@@/Defaults";
import { LeterPermissionType, LetrType } from "@@/Letr";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { MessageType } from "@@/Message";
import { Capability, RoleStatus } from "@@/Project";
import { CHATID, ChatTag, Tag, TagCategory, AssignedTag, ActiveCallTag } from "@@/Tags";
import { action, makeObservable, observable } from "mobx";
import { BaseDialogState } from "../UIComponents/BaseDialog";
import { NewTagDialogState } from "../UIComponents/NewTagDialog";
import { ChooseTagDialogState } from "../UIComponents/TagChooser";
import { LetrUI } from "./LetrUI";
import { NewLetrDialogState } from "./NewLetrDialogState";
import { Router } from "./Router";
import { comm } from "@/Comm/comm";
import { ServerPath } from "@@/ServerPath";
export var TagLoadStatus;
(function (TagLoadStatus) {
    TagLoadStatus[TagLoadStatus["Initial"] = 0] = "Initial";
    TagLoadStatus[TagLoadStatus["Loading"] = 1] = "Loading";
    TagLoadStatus[TagLoadStatus["Loaded"] = 2] = "Loaded";
})(TagLoadStatus || (TagLoadStatus = {}));
export class PluginDataStore {
    constructor() {
        this.showdialog = false;
        this.editingid = "";
        this.name = "";
        this.users = new Set();
        this.codepath = "";
        this.llmkey = "";
        this.schemas = new Set();
        this.schemafilter = "";
        this.saving = false;
        makeObservable(this);
    }
    setEdittingId(id) {
        this.editingid = id;
    }
    setSaving(saving) {
        this.saving = saving;
    }
    async savePlugin(letrid) {
        const plugin = {
            id: this.editingid,
            letrid: letrid,
            appusers: Array.from(this.users),
            attachedschemas: Array.from(this.schemas),
            pluginname: this.name,
            appcodepath: this.codepath,
            llmkey: this.llmkey
        };
        let pp = ServerPath.addplugin;
        if (this.editingid) {
            pp = ServerPath.updateplugin;
        }
        else {
        }
        const commbundles = await comm.post(pp, plugin);
        if (commbundles === undefined) {
            return undefined;
        }
        return commbundles;
    }
    setSchemaFilter(fil) {
        this.schemafilter = fil;
    }
    setName(name) {
        this.name = name;
    }
    setCodePath(path) {
        this.codepath = path;
    }
    setLLMKey(path) {
        this.llmkey = path;
    }
    setUsers(user) {
        this.users.clear();
        for (const u of user) {
            this.users.add(u);
        }
    }
    setSchemas(user) {
        this.schemas.clear();
        for (const u of user) {
            this.schemas.add(u);
        }
    }
    setShowDialog() {
        this.showdialog = true;
    }
    setHideDialog() {
        this.showdialog = false;
    }
    addUser(user) {
        this.users.add(user);
    }
    removeUser(user) {
        this.users.delete(user);
    }
    addSchema(user) {
        this.schemas.add(user);
    }
    removeSchema(user) {
        this.schemas.delete(user);
    }
    reset() {
        this.schemas.clear();
        this.name = "";
        this.codepath = "";
        this.users.clear();
        this.setEdittingId("");
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], PluginDataStore.prototype, "showdialog", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PluginDataStore.prototype, "editingid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PluginDataStore.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], PluginDataStore.prototype, "users", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PluginDataStore.prototype, "codepath", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PluginDataStore.prototype, "llmkey", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], PluginDataStore.prototype, "schemas", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PluginDataStore.prototype, "schemafilter", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], PluginDataStore.prototype, "saving", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], PluginDataStore.prototype, "setEdittingId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], PluginDataStore.prototype, "setSaving", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], PluginDataStore.prototype, "setSchemaFilter", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], PluginDataStore.prototype, "setName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], PluginDataStore.prototype, "setCodePath", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], PluginDataStore.prototype, "setLLMKey", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Set]),
    __metadata("design:returntype", void 0)
], PluginDataStore.prototype, "setUsers", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Set]),
    __metadata("design:returntype", void 0)
], PluginDataStore.prototype, "setSchemas", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], PluginDataStore.prototype, "setShowDialog", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], PluginDataStore.prototype, "setHideDialog", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], PluginDataStore.prototype, "addUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], PluginDataStore.prototype, "removeUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], PluginDataStore.prototype, "addSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], PluginDataStore.prototype, "removeSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], PluginDataStore.prototype, "reset", null);
export class LetrAndTagsStore {
    constructor() {
        this.maxLetrs = 100;
        this.letrCountAtTime = 20;
        this.newTagDialogState = new NewTagDialogState(() => { });
        this.tagsLoadStatus = TagLoadStatus.Initial;
        this.backupcopyletrsforfiltering = new Map();
        this.showletrmenu = false;
        this.letrLoadStatus = LetrLoadStatus.Initial;
        this.letrsById = new Map();
        this.tagsMap = new Map();
        this.selectedtag = "";
        this.selectedLetr = "";
        this.letrUIScrolled = false;
        this.loadinglogs = false;
        this.loadingrecentlogs = false;
        this.newplugindialog = new PluginDataStore();
        this.pluginmaps = new Map();
        this.edittingrole = false;
        this.loadingroles = false;
        this.editroleid = "";
        this.activeviewer = "home";
        this.activecustomtabid = "";
        this.roles = new Map();
        this.firstload = true;
        this.loadingletr = false;
        this.activepluginid = "";
        this.rolesdialogstate = new BaseDialogState();
        this.selectedLetrs = new Set();
        this.deleteingroleids = new Set();
        this.choosetagstore = new ChooseTagDialogState();
        this.sortedLetrsByTime = [];
        this.ongoingTagRequest = false;
        this.fetchingLetrs = false;
        this.creating = false;
        this.hasMoreLetrs = true;
        this.addroledialogstate = new BaseDialogState();
        this.lastLetrTime = 0;
        this.firstletrtime = -1;
        this.managedMode = false;
        this.activecallletrid = "";
        this.aitext = "";
        this.myperm = LeterPermissionType.View;
        this.activeview = "home";
        this.shownotifyview = false;
        this.actveltermembers = [];
        this.activeletrmemids = new Set();
        this.policiesaccepted = false;
        this.letrtype = LetrType.Letr;
        this.loadingpluginkey = false;
        this.newLetrDialog = new NewLetrDialogState();
        this.userid = "";
        this.letrlogstimeout = -1;
        this.showTagsMenu = false;
        this.showProjectsMenu = false;
        this.toggleselection = false;
        this.newrolename = "";
        this.caps = new Set();
        this.addingrole = false;
        this.activecaps = new Set();
        this.hasmorelogs = true;
        this.letrlogs = new Map();
        this.lastlogloadtime = -1;
        this.archiving = false;
        this.unarchiving = false;
        this.editmember = new Set();
        makeObservable(this);
        this.addroledialogstate.setHeaderLabel("Add Role");
        this.addroledialogstate.setOkLabel("Add");
        this.addroledialogstate.onOk = () => {
            this.addNewRole();
        };
        this.rolesdialogstate.setHeaderLabel("Letr Roles and Permissions");
        this.rolesdialogstate.setHideCancelButton(true);
        this.rolesdialogstate.setOkLabel("Close");
        this.rolesdialogstate.onOk = () => this.rolesdialogstate.setOpen(false);
        APPEvent.addSubscriberForUserID((id) => {
            this.userid = id;
        });
        APPEvent.addSubscriberForLetrEdit((res) => {
            if (res.detail !== undefined && this.letrsById.has(res.letrid)) {
                const lt = this.letrsById.get(res.letrid);
                lt === null || lt === void 0 ? void 0 : lt.setRecepient(res.detail.memberDetails.map((mem) => mem.id));
                lt === null || lt === void 0 ? void 0 : lt.setExternal(res.detail.isExternal);
            }
        });
        APPEvent.addSubcriberForUpdateRole((role) => {
            var _a, _b;
            if (((_a = role.role) === null || _a === void 0 ? void 0 : _a.letrid) === this.selectedLetr) {
                if (role.role) {
                    this.setRole(role.role);
                }
                if (this.editroleid === ((_b = role.role) === null || _b === void 0 ? void 0 : _b.id)) {
                    this.setAddingRole(false);
                    if (!role.ok) {
                        APPEvent.publishApperror("Sorrt, failed to add new role");
                    }
                    else {
                        this.addroledialogstate.setOpen(false);
                        this.setNewRoleName("");
                        this.clearcap();
                    }
                }
            }
        });
        APPEvent.addSubcriberForAddRole((role) => {
            var _a;
            if (((_a = role.role) === null || _a === void 0 ? void 0 : _a.letrid) === this.selectedLetr) {
                this.setRole(role.role);
            }
            if (this.addingrole) {
                this.setAddingRole(false);
                if (!role.ok) {
                    APPEvent.publishApperror("Sorrt, failed to add new role");
                }
                else {
                    this.addroledialogstate.setOpen(false);
                    this.setNewRoleName("");
                    this.clearcap();
                }
            }
        });
        APPEvent.addSubcriberForDeleteRole((role) => {
            if (this.deleteingroleids.has(role.id)) {
                this.deleteRole(role.id);
            }
        });
        APPEvent.addSubscriberForLetrLogs((logs) => {
            let letrlog = false;
            logs.forEach((lg) => {
                if (lg.letrid === this.selectedLetr) {
                    this.addLog(lg);
                    letrlog = true;
                    if (this.lastlogloadtime === -1 || this.lastlogloadtime > lg.entrytime) {
                        this.lastlogloadtime = lg.entrytime;
                    }
                    if (this.firstletrtime < lg.entrytime) {
                        this.firstletrtime = lg.entrytime;
                    }
                }
            });
            if (letrlog && logs.length < 20) {
                this.hasMoreLogs(false);
            }
            this.setLoadingLogs(false);
            this.setLoadingRecentLogs(false);
        });
        APPEvent.addSubcriberForGetRole((role) => {
            for (const ro of role) {
                if (ro.letrid === this.selectedLetr) {
                    this.setRole(ro);
                }
            }
            // we should check and update permission here again
            if (this.loadingroles && this.activeletrdetail) {
                this.setMyPermission(this.activeletrdetail.mypermission.permission);
                this.setMyCaps(this.activeletrdetail.mypermission);
                this.loadedLetrContent();
                if (this.letrres) {
                    APPEvent.publishLocalLetrDetail(this.letrres);
                }
            }
            this.loadingroles = false;
        });
        APPEvent.addSubscriberForTaggingLetr((resp) => {
            if (this.archiving && this.selectedLetrs.size > 0) {
                for (const lt of this.selectedLetrs) {
                    const letr = this.letrsById.get(lt);
                    if (letr !== undefined) {
                        // keep original standrad one and then we good to go now!
                        if (this.selectedtag != "archive") {
                            this.deleteLetr(letr.id);
                        }
                        letr.setTags(["archive"]);
                    }
                    this.removeSelectedLetr(lt);
                }
                this.archiving = false;
            }
            else if (this.unarchiving && this.selectedLetrs.size > 0) {
                for (const res of resp) {
                    if (res.ok) {
                        const letr = this.letrsById.get(res.id);
                        if (letr !== undefined) {
                            this.deleteLetr(letr.id);
                        }
                        letr === null || letr === void 0 ? void 0 : letr.setTags(["all"]);
                    }
                }
                for (const lt of this.selectedLetrs) {
                    this.removeSelectedLetr(lt);
                }
                this.unarchiving = false;
            }
        });
        APPEvent.addSubscriberForMediaShut(() => {
            this.activecallletrid = "";
        });
        APPEvent.addSubscriberForNewActiveLetrid((lt) => {
            const ltr = this.letrsById.get(lt);
            if (ltr !== undefined) {
                ltr.addTag("activecall");
            }
        });
        APPEvent.addSubscriberForTagsResponse((res) => {
            if (res.error && this.ongoingTagRequest) {
                APPEvent.publishApperror(res.error);
            }
            if (res.type === TagRequestType.Load) {
                res.tags.forEach((t) => this.addTag(t));
                this.setLoadStatus(TagLoadStatus.Loaded);
            }
            else if (res.type === TagRequestType.Add) {
                res.tags.forEach((t) => this.addTag(t));
            }
            else if (res.type === TagRequestType.Delete) {
                res.tags.forEach((t) => this.deleteTag(t));
            }
        });
        APPEvent.addSubscriberForLetrsResponse(lres => {
            var _a;
            if (lres.type === LetrRequestType.FetchDetail &&
                lres.letrdetail !== undefined) {
                const lt = this.letrsById.get(lres.letrid);
                if ((lt === null || lt === void 0 ? void 0 : lt.id) === this.selectedLetr && !this.loadingroles) {
                    this.setMyPermission(lres.letrdetail.mypermission.permission);
                    this.setMyCaps(lres.letrdetail.mypermission);
                    this.loadedLetrContent();
                    APPEvent.publishLocalLetrDetail(lres);
                }
                else if ((lt === null || lt === void 0 ? void 0 : lt.id) === this.selectedLetr && this.loadingroles) {
                    this.letrres = lres;
                }
                if (lt !== undefined) {
                    const tags = (_a = lres.letrdetail) === null || _a === void 0 ? void 0 : _a.tags;
                    if (tags !== undefined) {
                        if (tags.indexOf("activecall") > -1) {
                            lt.addTag("activecall");
                        }
                        else {
                            lt.removeTag("activecall");
                        }
                    }
                }
                if ((lt === null || lt === void 0 ? void 0 : lt.id) === this.selectedLetr) {
                    this.activeletrdetail = lres.letrdetail;
                    this.setActiveLetrMembers(lres.letrdetail.memberDetails);
                    this.setMemberIds();
                }
                return;
            }
            let selid = "";
            let hasuniue = false;
            if (lres.letrs.length > 0) {
                hasuniue = lres.letrs.filter((l) => !this.letrsById.has(l.id)).length > 0;
                lres.letrs.forEach(lt => this.addLetr(this.convertLetrToLetrUI(lt)));
                selid = lres.letrs[0].id;
            }
            this.adjustLetrsCount();
            if (this.fetchingLetrs && lres.type === LetrRequestType.Fetch) {
                if (lres.letrs.length > 0) {
                    // over here we should just do basic stuff now!!
                    // if there is url stuff we should just do that now!
                    if (this.firstload) {
                        const aroute = Router.getActiveRoute();
                        if (aroute != undefined) {
                            const ml = InMemoryRepo.getLetridFromOrigId(aroute.letrid);
                            if (ml && this.letrsById.has(ml)) {
                                this.setActiveLetr(ml);
                            }
                            else {
                                this.setShowProjectsMenu(true);
                            }
                            // now we just need to add the right view
                            // now we can do 
                        }
                        else {
                            this.setShowProjectsMenu(true);
                        }
                    }
                    else {
                        this.setShowProjectsMenu(true);
                    }
                }
                this.fetchingLetrs = false;
                this.setLetrLoadStatus(LetrLoadStatus.Loaded);
                this.setHasMoreLetrs(false);
            }
            if (this.creating && lres.type === LetrRequestType.Add) {
                this.setCreating(false);
                this.setActiveLetr(selid);
                if (this.selectedtag === CHATID) {
                    this.setActiveView('chat');
                    this.setActiveViewer('chat');
                }
                else {
                    this.setActiveView("project");
                    this.setActiveViewer("project");
                }
                this.setShowProjectsMenu(false);
                APPEvent.publishNewLetr();
            }
        });
        APPEvent.addSubscriberForChildTags((tags) => {
            // this is always full show so anything missing remove those tags
            const tids = new Set();
            const del = this.tagsMap.size;
            for (const tag of tags) {
                if (tag.parent) {
                    this.addTag(tag);
                    tids.add(tag.id);
                }
            }
            if (del) {
                for (const id of Array.from(this.tagsMap.values())) {
                    if (id.parent && !tids.has(id.id)) {
                        this.deleteTag(id);
                    }
                }
            }
        });
        APPEvent.addSubscriberForMessageResponse((res) => {
            if (res.parentid !== "") {
                return;
            }
            const msg = res.msg;
            const letrid = res.letrid;
            const letr = this.letrsById.get(letrid);
            if (letr !== undefined) {
                msg.sort(this.sortMessages);
                const lmsg = msg.filter(m => m.type === MessageType.Text);
                if (lmsg !== undefined && lmsg.length > 0) {
                    const mg = lmsg[lmsg.length - 1];
                    if (letr.updatetime < mg.createdAt) {
                        letr.setLastmessage(mg.text);
                    }
                }
                if (msg != null && msg.length > 0) {
                    const lastmsg = msg[msg.length - 1];
                    if (letr.updatetime < lastmsg.createdAt) {
                        letr.setUpdateTime(lastmsg.createdAt);
                    }
                }
            }
        });
        APPEvent.addSubscriberForPoliciesAccepted((res) => {
            this.policiesaccepted = res;
        });
    }
    setAiDetail(aitext) {
        this.aitext = aitext;
    }
    async getLetrAiKey() {
        var _a, _b;
        if (!this.selectedLetr)
            return;
        let req = {
            id: (_a = this.selectedLetr) !== null && _a !== void 0 ? _a : '',
            projectid: (_b = this.selectedLetr) !== null && _b !== void 0 ? _b : '',
            schemaid: '',
            aitext: '',
            userid: '',
            webformid: ''
        };
        let res = await comm.post(ServerPath.getAiText, req);
        if (res !== undefined && req.projectid === this.selectedLetr) {
            this.setAiDetail(res.aitext);
        }
    }
    setToggleSelection(select) {
        if (!select) {
            this.selectedLetrs.clear();
        }
        this.toggleselection = select;
    }
    setActiveLetrMembers(mem) {
        this.actveltermembers.splice(0, this.actveltermembers.length);
        this.actveltermembers.push(...mem);
    }
    setLoadingPluginKey(loading) {
        this.loadingpluginkey = loading;
    }
    async fetchPluginApiKey(pluginid) {
        const res = await comm.post(ServerPath.getApiKeyForUserForOrg, {
            letrid: this.selectedLetr,
            pluginid: pluginid
        });
        return res;
    }
    setShowNotifyView(show) {
        this.shownotifyview = show;
    }
    setActiveCustomtabid(id) {
        this.activecustomtabid = id;
    }
    setRole(role) {
        this.roles.set(role.id, role);
    }
    setAddingRole(add) {
        this.addingrole = add;
    }
    deleteRole(id) {
        this.roles.delete(id);
        this.deleteingroleids.delete(id);
    }
    setMyCaps(perm) {
        this.activecaps.clear();
        let roleid = perm.roleid;
        if (roleid) {
            const role = this.roles.get(roleid);
            if (role) {
                role.capability.forEach(this.activecaps.add, this.activecaps);
            }
        }
    }
    hasMoreLogs(has) {
        this.hasmorelogs = has;
    }
    setNewRoleName(name) {
        this.newrolename = name;
    }
    addCap(cap) {
        this.caps.add(cap);
    }
    deleteCap(cap) {
        this.caps.delete(cap);
    }
    clearcap() {
        this.caps.clear();
    }
    setMemberIds() {
        this.activeletrmemids.clear();
        this.actveltermembers.forEach((m) => this.activeletrmemids.add(m.id));
    }
    sortMessages(m1, m2) {
        return m1.createdAt - m2.createdAt;
    }
    setMyPermission(perm) {
        this.myperm = perm;
    }
    canAddDatasheetLink() {
        return this.activecaps.has(Capability.AddDatasheetLink) || this.canManageDatasheet() || this.canManageSchema();
    }
    canManageRows() {
        return this.activecaps.has(Capability.ManageRows);
    }
    canAddNotes() {
        return this.activecaps.has(Capability.AddDocumentNote) || this.canManageDocuments();
    }
    canViewDocument() {
        return this.activecaps.has(Capability.ViewDocument);
    }
    canManageUser() {
        return this.activecaps.has(Capability.ManageUser);
    }
    canViewUsers() {
        return this.activecaps.has(Capability.ViewUser);
    }
    canManageSchema() {
        return this.activecaps.has(Capability.ManageSchema);
    }
    canManageDocuments() {
        return this.activecaps.has(Capability.ManageDocument);
    }
    canExportDocuments() {
        return this.activecaps.has(Capability.ExportDocument);
    }
    canUploadDocuments() {
        return this.canManageDocuments() ||
            this.activecaps.has(Capability.UploadDocument);
    }
    canViewDatasheet() {
        return this.activecaps.has(Capability.ViewDatasheet);
    }
    canManageDatasheet() {
        return this.activecaps.has(Capability.ManageDatasheet);
    }
    setLetrType(bl) {
        this.letrtype = bl;
    }
    getRoleCapabilities() {
        return Object.keys(Capability);
    }
    getRoles() {
        return Array.from(this.roles.values()).slice().sort((r1, r2) => {
            if (r1.id.endsWith("_admin"))
                return -1;
            if (r2.id.endsWith("_admin"))
                return 1;
            if (r1.id.endsWith("_editor"))
                return -1;
            if (r2.id.endsWith("_editor"))
                return 1;
            if (r1.id.endsWith("_viewer"))
                return -1;
            if (r2.id.endsWith("_viewer"))
                return 1;
            return r1.name.toLowerCase().localeCompare(r2.name.toLowerCase());
        });
    }
    addNewRole() {
        if (!this.newrolename) {
            return;
        }
        this.setAddingRole(true);
        const role = {
            id: this.edittingrole ? this.editroleid : '',
            letrid: this.selectedLetr,
            capability: Array.from(this.caps),
            name: this.newrolename,
            status: RoleStatus.Live
        };
        Apphandler.sendMessage(this.edittingrole ? 'updaterole' : "addrole", role);
    }
    setActiveFilter(fil) {
        this.activefilter = fil;
    }
    setShowProjectsMenu(show) {
        this.showProjectsMenu = show;
    }
    setShowTagsMenu(show) {
        this.showTagsMenu = show;
    }
    async loadLetrPlugins() {
        if (!this.selectedLetr)
            return;
        const req = {
            letrid: this.selectedLetr
        };
        const plugins = await comm.post(ServerPath.getPlugins, req);
        this.pluginmaps.clear();
        if (plugins !== undefined) {
            for (const plugin of plugins) {
                this.setPlugin(plugin);
            }
        }
    }
    setPlugin(plugin) {
        this.pluginmaps.set(plugin.id, plugin);
    }
    showTagChooser() {
        var _a;
        // standard tag ids are 
        const sls = Array.from(this.selectedLetrs);
        if (sls.length === 1) {
            const tags = (_a = this.letrsById.get(sls[0])) === null || _a === void 0 ? void 0 : _a.tags;
            if (tags !== undefined) {
                for (const tg of tags) {
                    if (!DEFAULT_TAGS.standardtagsids.has(tg)) {
                        this.choosetagstore.setSelectedTag(tg, true);
                    }
                }
            }
        }
        this.choosetagstore.updatecb = (ids) => {
            for (const lt of this.selectedLetrs) {
                const letr = this.letrsById.get(lt);
                if (letr !== undefined) {
                    // keep original standrad one and then we good to go now!
                    const stags = Array.from(letr.tags).filter((t) => DEFAULT_TAGS.standardtagsids.has(t));
                    letr.setTags(Array.from(new Set([...stags, ...ids])));
                }
            }
        };
        this.choosetagstore.applyCb = (ids) => {
            this.archiving = false;
            this.unarchiving = false;
            // lets add one by one and we good to go!
            const req = [];
            for (const lt of this.selectedLetrs) {
                const letr = this.letrsById.get(lt);
                if (letr !== undefined) {
                    // keep original standrad one and then we good to go now!
                    const stags = Array.from(letr.tags).filter((t) => DEFAULT_TAGS.standardtagsids.has(t));
                    req.push({
                        tagids: Array.from(new Set([...stags, ...ids])),
                        letrid: lt
                    });
                }
            }
            if (req.length > 0) {
                Apphandler.sendMessage("addtagtoletr", req);
            }
        };
        this.choosetagstore.tags = this.getChildrenTags("file");
        this.choosetagstore.setOpen(true);
    }
    getLetrNonStandardTags(ids) {
        const ret = [];
        for (const id of ids) {
            if (DEFAULT_TAGS.standardtagsids.has(id)) {
                continue;
            }
            const tag = this.tagsMap.get(id);
            if (tag !== undefined) {
                ret.push(tag);
            }
        }
        return ret;
    }
    setActiveViewer(viewer) {
        this.activeviewer = viewer;
    }
    setActiveHome() {
        Router.setActiveHome();
    }
    setActivePlugin(id) {
        this.activepluginid = id;
    }
    setActiveView(aview) {
        if (this.activeview === aview) {
            return;
        }
        this.activeview = aview;
        if (aview !== 'plugin') {
            this.setActivePlugin("");
        }
        this.setLetrOptionMenu(false);
    }
    setCreating(creating) {
        this.creating = creating;
    }
    setHasMoreLetrs(hm) {
        this.hasMoreLetrs = hm;
    }
    setLetrUIScrolled(scrolled) {
        this.letrUIScrolled = scrolled;
    }
    loadDefaultTagLetrs() {
        const dtid = this.getDefaultTag();
        this.setSelectedTag(dtid);
        this.loadTagsLetr(dtid);
    }
    getLetrById(id) {
        return this.letrsById.get(id);
    }
    letrIsFlagged(letr) {
        const ftag = this.getFlagtag();
        if (ftag === undefined) {
            return false;
        }
        if (letr.tags.has(ftag.id)) {
            return true;
        }
        return false;
    }
    isReaodnly(letrid) {
        var _a, _b;
        return (_b = (_a = this.letrsById.get(letrid)) === null || _a === void 0 ? void 0 : _a.readonly) !== null && _b !== void 0 ? _b : false;
    }
    createNewTag(name, parentagid, color = "black") {
        const newtag = new Tag("", name, false, TagCategory.userdefined, undefined, false, false, false, false, parentagid);
        newtag.color = color;
        const treq = {
            type: TagRequestType.Add,
            tags: [newtag]
        };
        Apphandler.sendMessage("tags", treq);
    }
    showOnlyActiveTagsLetr() {
        this.setActiveLetr("");
        this.fetchingLetrs = true;
        this.setLetrLoadStatus(LetrLoadStatus.Loading);
        for (const [_, letr] of this.letrsById) {
            letr.setShow(false);
            if (letr.tags.has(this.selectedtag)) {
                letr.setShow(true);
            }
        }
        this.setLetrLoadStatus(LetrLoadStatus.Loaded);
        this.fetchingLetrs = false;
    }
    selectTagAndLoadLetrs(tagid) {
        this.setActiveFilter(undefined);
        this.setSelectedTag(tagid);
        this.loadTagsLetr(tagid);
        APPEvent.publishActiveLetr("");
    }
    setLoadingLogs(loading) {
        this.loadinglogs = loading;
    }
    filterTagsLetr(filter) {
        if (this.fetchingLetrs) {
            return;
        }
        this.setActiveLetr("");
        this.fetchingLetrs = true;
        this.setLetrLoadStatus(LetrLoadStatus.Loading);
        mainloop: for (const [_, letr] of this.letrsById) {
            letr.setShow(false);
            if (filter.before > -1 &&
                letr.updatetime > filter.before) {
                continue;
            }
            if (filter.after > -1 && letr.updatetime < filter.after) {
                continue;
            }
            if (filter.tagid && !letr.tags.has(filter.tagid)) {
                continue;
            }
            if (filter.contains && letr.subject.toLowerCase().indexOf(filter.contains.toLowerCase()) === -1) {
                continue;
            }
            if (filter.selectedGroup && filter.selectedGroup.length > 0) {
                for (const grp of filter.selectedGroup) {
                    if (letr.recipients.indexOf(grp) === -1) {
                        continue mainloop;
                    }
                }
            }
            letr.setShow(true);
        }
        this.setActiveFilter(filter);
        this.setLetrLoadStatus(LetrLoadStatus.Loaded);
        this.fetchingLetrs = false;
    }
    resetTagsLetr() {
        if (this.fetchingLetrs) {
            return;
        }
        this.setActiveFilter(undefined);
        this.fetchingLetrs = true;
        this.setLetrLoadStatus(LetrLoadStatus.Loading);
        for (const [_, letr] of this.letrsById) {
            letr.setShow(true);
        }
        this.setLetrLoadStatus(LetrLoadStatus.Loaded);
        this.fetchingLetrs = false;
    }
    loadTagsLetr(tagid) {
        if (this.fetchingLetrs) {
            return;
        }
        this.fetchingLetrs = true;
        this.setLetrLoadStatus(LetrLoadStatus.Loading);
        this.loadTagletrs(tagid, new Date().getTime() + (60 * 1000));
        this.resetLetrMap();
    }
    loadMoreLetrs() {
        if (this.selectedtag && !this.fetchingLetrs) {
            this.fetchingLetrs = true;
            this.loadTagletrs(this.selectedtag, this.lastLetrTime);
        }
    }
    loadTagletrs(tagid, time) {
        let ufilter;
        if (this.activefilter !== undefined) {
            this.activefilter.before = time;
            this.activefilter.count = 20;
            ufilter = this.activefilter;
        }
        else {
            const filter = {
                tagid: tagid,
                before: time,
                count: Math.max(),
                after: 20,
            };
            ufilter = filter;
        }
        const req = {
            type: LetrRequestType.Fetch,
            filter: ufilter
        };
        Apphandler.sendMessage('letrs', req);
    }
    toggleLetrOptionMenu() {
        this.setLetrOptionMenu(!this.showletrmenu);
    }
    setLetrOptionMenu(show) {
        this.showletrmenu = show;
    }
    setLoadingLetr(loading) {
        this.loadingletr = loading;
    }
    getDefaultTag() {
        return "all";
    }
    getFlagtag() {
        for (const t of this.tagsMap) {
            const tag = t[1];
            if (tag !== undefined && tag.id === "flag") {
                return tag;
            }
        }
        return undefined;
    }
    getArchiveTag() {
        for (const t of this.tagsMap) {
            const tag = t[1];
            if (tag !== undefined && tag.id === "archive") {
                return tag;
            }
        }
        return undefined;
    }
    deleteLetrRole(id) {
        this.deleteingroleids.add(id);
        const role = {
            id: id,
            letrid: this.selectedLetr,
            name: '',
            status: RoleStatus.Dead,
            capability: []
        };
        Apphandler.sendMessage("deleterole", role);
    }
    loadTags() {
        if (this.tagsLoadStatus === TagLoadStatus.Initial) {
            this.setLoadStatus(TagLoadStatus.Loading);
            const req = {
                type: TagRequestType.Load,
                tags: []
            };
            Apphandler.sendMessage("tags", req);
        }
    }
    addLetr(letr) {
        if (letr.tags.has(this.selectedtag) || (this.selectedtag === 'archive' &&
            letr.tags.has("userarchive"))) {
            this.letrsById.set(letr.id, letr);
            if (this.lastLetrTime === 0 || this.lastLetrTime > letr.updatetime) {
                this.lastLetrTime = letr.updatetime;
            }
        }
    }
    addTag(tag) {
        this.tagsMap.set(tag.id, tag);
    }
    deleteTag(tag) {
        this.tagsMap.delete(tag.id);
    }
    setLoadStatus(status) {
        this.tagsLoadStatus = status;
    }
    setLetrLoadStatus(status) {
        this.letrLoadStatus = status;
    }
    setSelectedTag(tid) {
        this.selectedtag = tid;
        Apphandler.sendMessage("activetag", tid);
    }
    getLetrs() {
    }
    getTopLevelTags() {
        return Array.from(this.tagsMap.values()).filter((t) => !t.parent && !t.isPrivateTag && !t.isGroupTag);
    }
    getDirectMessageTag() {
        return ChatTag;
    }
    getAssginedTag() {
        return AssignedTag;
    }
    getActiveCallTag() {
        return ActiveCallTag;
    }
    getChildrenTags(parentid) {
        return Array.from(this.tagsMap.values()).filter((t) => (t.parent && t.parent === parentid));
    }
    resetLetrMap() {
        this.letrsById = new Map();
        this.selectedLetrs = new Set();
        this.lastLetrTime = 0;
        this.actveltermembers = [];
        this.activeletrmemids = new Set();
        this.activecustomtabid = '';
    }
    getNameForLetrUser(id) {
        if (this.actveltermembers.length > 0) {
            for (const m of this.actveltermembers) {
                console.log(m.id + "===" + id);
                if (m.id === id) {
                    return m.name + "(" + m.orgname + ")";
                }
            }
        }
        console.log("returning ");
        return "Unknown";
    }
    letrLoaded() {
        if (this.selectedtag === CHATID) {
            this.setActiveView('chat');
        }
        else {
            // we can set active view!
            if (this.firstload) {
                const aroute = Router.getInitialRoute();
                let added = false;
                if (aroute) {
                    const tab = aroute.tab;
                    if (tab === 'Datasheet' && this.canViewDatasheet()) {
                        this.setActiveView("datasheet");
                        // also set the 
                        added = true;
                    }
                    else if (tab === 'Document' && this.canViewDocument()) {
                        this.setActiveView('project');
                        added = true;
                    }
                }
                if (!added) {
                    this.setActiveView("home");
                }
            }
            else {
                // if(this.canViewDocument()) {
                //     this.setActiveView("project");
                // }else if(this.canViewDatasheet()) {
                //     this.setActiveView("datasheet");
                // }else {
                //     this.setActiveView("no-access");
                // }
                this.setActiveView("home");
            }
        }
        this.firstload = false;
    }
    loadedLetrContent() {
        this.letrLoaded();
        const mreq = {
            id: this.selectedLetr,
            isChooser: false
        };
        Apphandler.sendMessage("getmetadata", mreq);
        const lre = {
            letrid: this.selectedLetr,
        };
        Apphandler.sendMessage("getletrlink", lre);
        APPEvent.publishActiveLetr(this.selectedLetr);
        setTimeout(() => this.setLoadingLetr(false), 100); //time for other store too get ready
    }
    addLog(log) {
        this.letrlogs.set(log.id, log);
    }
    setLoadingRecentLogs(loading) {
        this.loadingrecentlogs = loading;
    }
    loadRecentLogs() {
        if (this.loadingrecentlogs) {
            return;
        }
        this.setLoadingRecentLogs(true);
        let time = new Date().getTime();
        if (this.firstletrtime > -1) {
            time = this.firstletrtime;
        }
        const req = {
            reverse: true,
            letrid: this.selectedLetr,
            count: 10,
            request: time,
            ignorids: Array.from(this.letrlogs.values()).filter((lr) => lr.entrytime === time).map((lt) => lt.id)
        };
        Apphandler.sendMessage("getletrlogs", req);
    }
    loadLetrLogs() {
        if (this.loadinglogs) {
            return;
        }
        let time = new Date().getTime();
        if (this.lastlogloadtime > -1) {
            time = this.lastlogloadtime;
        }
        const req = {
            reverse: false,
            letrid: this.selectedLetr,
            count: 20,
            request: time,
            ignorids: Array.from(this.letrlogs.values()).filter((lr) => lr.entrytime === time).map((lt) => lt.id)
        };
        this.setLoadingLogs(true);
        Apphandler.sendMessage("getletrlogs", req);
    }
    setActiveLetr(id, isHome = false) {
        if (this.letrlogstimeout) {
            clearTimeout(this.letrlogstimeout);
        }
        this.selectedLetr = id;
        this.roles.clear();
        this.lastlogloadtime = -1;
        this.firstletrtime = -1;
        this.setLoadingLogs(false);
        this.setShowNotifyView(false);
        this.letrlogs.clear();
        this.deleteingroleids.clear();
        this.edittingrole = false;
        this.editroleid = "";
        this.newrolename = "";
        this.hasMoreLogs(true);
        this.setAddingRole(false);
        this.caps.clear();
        this.addroledialogstate.setOpen(false);
        this.rolesdialogstate.setOpen(false);
        this.activecustomtabid = '';
        if (!id) {
            return;
        }
        this.getLetrAiKey();
        this.loadingroles = true;
        this.setLoadingLetr(true);
        const lt = InMemoryRepo.getLetrOid(id);
        if (lt) {
            Router.setActiveLetr(lt, isHome);
        }
        const req = {
            type: LetrRequestType.FetchDetail,
            letrid: id
        };
        this.actveltermembers = [];
        this.setLetrOptionMenu(false);
        this.loadLetrPlugins();
        const treq = {
            letrid: id
        };
        if (id) {
            Apphandler.sendMessage("letrs", req);
            Apphandler.sendMessage("getroles", id);
            Apphandler.sendMessage("gettabs", treq);
            Apphandler.sendMessage("buildnameindex", id);
        }
    }
    setLetrSelected(id, bol) {
        if (bol) {
            this.addToSelectedLetr(id);
        }
        else {
            this.removeSelectedLetr(id);
        }
    }
    addToSelectedLetr(id) {
        this.selectedLetrs.add(id);
    }
    deleteLetr(id) {
        this.letrsById.delete(id);
    }
    removeSelectedLetr(id) {
        this.selectedLetrs.delete(id);
    }
    letrIsSelected(id) {
        if (!id) {
            return false;
        }
        return this.selectedLetrs.has(id);
    }
    setManagedMode(mode) {
        this.managedMode = mode;
    }
    reset() {
        this.setMyPermission(LeterPermissionType.View);
        this.activecaps.clear();
        this.tagsMap = new Map();
        this.selectedLetr = "";
        this.resetLetrMap();
        this.setLoadStatus(TagLoadStatus.Initial);
        this.setLetrLoadStatus(LetrLoadStatus.Initial);
        this.setActiveLetr("");
        this.setSelectedTag("");
        this.setManagedMode(false);
        this.setToggleSelection(false);
    }
    //Change to private
    convertLetrToLetrUI(letr) {
        const lui = new LetrUI();
        lui.id = letr.id;
        lui.setAuthorName(letr.authorname);
        lui.setUpdateTime(letr.letrMetadata.updatetime);
        lui.setSubject(letr.letrMetadata.subject);
        lui.setTags(letr.letrMetadata.tags);
        lui.setExternal(letr.isExternal);
        lui.setHasConnects(letr.hasConnects);
        let message = '';
        if (letr.lastmessage != undefined) {
            message = letr.lastmessage;
        }
        lui.setLastmessage(message);
        lui.setRecepient(letr.recipients);
        lui.setIsGroup(this.checkIfLetrIsGroup(letr));
        lui.readonly = letr.readonly;
        lui.setLetrType(letr.letrtype);
        lui.setAuthor(letr.author);
        lui.origletrid = letr.origletrid;
        return lui;
    }
    checkIfLetrIsGroup(letr) {
        const memset = new Set(letr.recipients);
        memset.add(letr.author);
        if (memset.size > 2) {
            return true;
        }
        if (letr.numberofconnects > 0 && letr.hasConnects) {
            return true;
        }
        return false;
    }
    unArchiveLetrs() {
        this.unarchiving = true;
        const req = [];
        for (const lt of this.selectedLetrs) {
            const letr = this.letrsById.get(lt);
            if (letr !== undefined) {
                req.push({
                    tagids: ["unarchive"],
                    letrid: lt
                });
            }
        }
        if (req.length > 0) {
            Apphandler.sendMessage("addtagtoletr", req);
        }
    }
    archiveLetrs() {
        this.archiving = true;
        const req = [];
        for (const lt of this.selectedLetrs) {
            const letr = this.letrsById.get(lt);
            if (letr !== undefined) {
                req.push({
                    tagids: ["archive"],
                    letrid: lt
                });
            }
        }
        if (req.length > 0) {
            Apphandler.sendMessage("addtagtoletr", req);
        }
    }
    createNewLetr(subject, recs, hidden, connectids, connectemailhint) {
        this.setCreating(true);
        const tags = new Set();
        let isChat = false;
        if (!this.selectedtag || this.selectedtag !== CHATID) {
            tags.add("all");
        }
        else if (this.selectedtag === CHATID) {
            subject = "Direct Message";
            isChat = true;
        }
        if (this.selectedtag) {
            tags.add(this.selectedtag);
        }
        if (isChat) {
            const ids = new Set();
            recs.forEach((rc) => ids.add(rc.userid));
            ids.add(this.userid);
            const id = LetrwingCrypto.hash512str([...Array.from(ids), this.userid].sort((a, b) => a > b ? 1 : a < b ? -1 : 0).join(","));
            if (this.letrsById.has(id)) {
                // we hav ethis chat 
                this.newLetrDialog.setEditting(false);
                this.newLetrDialog.setOpen(false);
                this.setActiveLetr(id);
                this.setCreating(false);
                return;
            }
        }
        const req = {
            type: LetrRequestType.Add,
            newletrreq: {
                tagids: Array.from(tags),
                subject: subject,
                members: recs,
                hidden: hidden,
                connectids: connectids,
                connectemailhint: connectemailhint,
                letrtype: this.letrtype,
            }
        };
        Apphandler.sendMessage("letrs", req);
    }
    adjustLetrsCount() {
    }
    getSortedLetrs() {
        return Array.from(this.letrsById.values()).slice().filter((lt) => lt.show).sort(this.sortLetrByTime).reverse();
    }
    sortLetrByTime(l1, l2) {
        return l1.updatetime - l2.updatetime;
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], LetrAndTagsStore.prototype, "tagsLoadStatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "showletrmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], LetrAndTagsStore.prototype, "letrLoadStatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], LetrAndTagsStore.prototype, "letrsById", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], LetrAndTagsStore.prototype, "tagsMap", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], LetrAndTagsStore.prototype, "selectedtag", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], LetrAndTagsStore.prototype, "selectedLetr", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "letrUIScrolled", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "loadinglogs", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "loadingrecentlogs", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "newplugindialog", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], LetrAndTagsStore.prototype, "pluginmaps", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], LetrAndTagsStore.prototype, "activeviewer", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "activecustomtabid", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], LetrAndTagsStore.prototype, "roles", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "loadingletr", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "activepluginid", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], LetrAndTagsStore.prototype, "selectedLetrs", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], LetrAndTagsStore.prototype, "deleteingroleids", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "creating", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "activefilter", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "hasMoreLetrs", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "aitext", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "myperm", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], LetrAndTagsStore.prototype, "activeview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "shownotifyview", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], LetrAndTagsStore.prototype, "actveltermembers", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], LetrAndTagsStore.prototype, "activeletrmemids", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], LetrAndTagsStore.prototype, "policiesaccepted", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], LetrAndTagsStore.prototype, "letrtype", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "loadingpluginkey", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], LetrAndTagsStore.prototype, "showTagsMenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], LetrAndTagsStore.prototype, "showProjectsMenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], LetrAndTagsStore.prototype, "toggleselection", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "newrolename", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], LetrAndTagsStore.prototype, "caps", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "addingrole", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], LetrAndTagsStore.prototype, "activecaps", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrAndTagsStore.prototype, "hasmorelogs", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], LetrAndTagsStore.prototype, "letrlogs", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], LetrAndTagsStore.prototype, "editmember", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setAiDetail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setToggleSelection", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setActiveLetrMembers", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setLoadingPluginKey", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setShowNotifyView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setActiveCustomtabid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setRole", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setAddingRole", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "deleteRole", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setMyCaps", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "hasMoreLogs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setNewRoleName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "addCap", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "deleteCap", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "clearcap", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setMemberIds", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setMyPermission", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setLetrType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setActiveFilter", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setShowProjectsMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setShowTagsMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setActiveViewer", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setActivePlugin", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setActiveView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setCreating", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setHasMoreLetrs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setLetrUIScrolled", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setLoadingLogs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setLetrOptionMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setLoadingLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "deleteLetrRole", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [LetrUI]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "addLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Tag]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "addTag", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Tag]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "deleteTag", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setLoadStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setLetrLoadStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setSelectedTag", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "resetLetrMap", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "addLog", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setLoadingRecentLogs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "loadRecentLogs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Boolean]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "setActiveLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "addToSelectedLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "deleteLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "removeSelectedLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LetrAndTagsStore.prototype, "reset", null);
